
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(49|59|685)|63(14|61)|79(26|65)|9(525|540|626)|2559|2670|3597|3799|4121|820)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
